






















import { Rate } from 'vant';
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class MyRate extends Vue {
  @Prop({ type: Number, required: true }) private value!: 0;
  @Prop({ type: Boolean, required: false }) private readonly!: true;

  private myValue = this.value;
  @Emit('change')
  private onModelChange(val: any) {
    console.log(val);
    return val;
  }
}
